import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 4;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'reports-overview',
      title: `Balance Sheet <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'This report shows your organization\'s financial position — assets, liabilities, and equity as of a specific date. Data updates in real-time.',
      attachTo: { element: '[data-tour="reports-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'reports-date-selector',
      title: `Date Selector <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Change the report date to view your financial position at any point in time. The report regenerates instantly.',
      attachTo: { element: '[data-tour="reports-date-selector"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'reports-export',
      title: `Export Options <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Export your reports as PDF or Excel. You can also share a link with specific date and fund settings.',
      attachTo: { element: '[data-tour="reports-export-buttons"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'reports-nav',
      title: `Report Navigation <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Switch between report types using these pills — Balance Sheet, Income Statement, General Ledger, Transactions List, and more.',
      attachTo: { element: '[data-tour="nav-top-pills"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'reports',
  pathPattern: '/reports/balance-sheet',
  getSteps,
  label: 'Reports Tour',
});
